var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state.isError)?_c('div',{attrs:{"id":"error"}},[_vm._v(" "+_vm._s(_vm.state.errorMsg)+" ")]):_c('div',{attrs:{"id":"app"}},[_c('Controller',{attrs:{"state":this.state}}),_c('Game',{attrs:{"state":this.state}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }